import { reactive } from 'vue';

const toasts = reactive([]);
let nextId = 0;

export function addApiErrorToast(status, method, url, message) {
  const id = ++nextId;
  toasts.push({ id, status, method, url, message });
  setTimeout(() => removeToast(id), 10000);
}

export function addToast(message, type = 'error') {
  const id = ++nextId;
  toasts.push({ id, message, type });
  setTimeout(() => removeToast(id), 5000);
}

export function removeToast(id) {
  const idx = toasts.findIndex((t) => t.id === id);
  if (idx !== -1) toasts.splice(idx, 1);
}

export function useToast() {
  return { toasts, removeToast };
}
